<!-- prettier-ignore -->
<span *ngFor="let chunk of chunks" [class.highlight]="chunk.highlight">{{chunk.text}}</span>
